import "./App.css";

import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import mapDispatchToProps from "../../common/app/mapDispatchToProps";
import mapStateToProps from "../../common/app/mapStateToProps";
import Helmet from "react-helmet";
import RouterHandler from "../../common/components/RouterHandler.react";
import { connect } from "react-redux";

import classNames from "classnames";
import NotificationSystem from "react-notification-system";
import isOnline from "is-online";

import {
  getAuthCookie,
  clearAuthCookie,
  setAuthCookie
} from "../../common/lib/auth";
import cookie from "cookie-dough";

import { addNotificationsForInvalidFields } from "../lib/validationWeb";

import { default as TouchBackend } from "react-dnd-touch-backend";
import { DragDropContext } from "react-dnd";
import HTML5Backend from "react-dnd-html5-backend";

class App extends Component {
  static propTypes = {
    children: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    msg: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired,
    settings: PropTypes.object.isRequired
  };

  constructor() {
    super();

    this.timeoutTime = 2000;
    this.pathTimeout = null;
    this.postTimeout = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;

    const { actions } = this.props;
    let isOnlineInterval = setInterval(() => {
      isOnline(function(online) {
        actions.setOnline(online);
      });
    }, 20000);
    actions.setIsOnlineInterval(isOnlineInterval);

    const self = this;
    let refreshTokenInterval = setInterval(() => {
      if (viewer) {
        self.checkAndRefreshToken();
      }
    }, 10000);
    actions.setRefreshTokenInterval(refreshTokenInterval);

    const { users: { viewer } } = this.props;
    if (viewer && viewer.accessToken) {
      actions.getCurrentUser().then(({ error, payload }) => {
        if (error) {
          addNotificationsForInvalidFields(payload, this._notificationSystem);
        }
      });
    }

    let mql = window.matchMedia(`(min-width: 64em)`);
    mql.addListener(actions.updateMediaQuery);
    actions.setSidebar("mql", mql);
    actions.setSidebar("docked", mql.matches);
  }

  componentDidUpdate(prevProps) {
    const { actions, settings } = this.props;

    if (!prevProps.settings.patchSuccess && settings.patchSuccess) {
      clearTimeout(this.pathTimeout);
      this.pathTimeout = setTimeout(() => {
        actions.setPatchSuccessFalse();
      }, this.timeoutTime);
    }
    if (!prevProps.settings.postSuccess && settings.postSuccess) {
      clearTimeout(this.postTimeout);
      this.postTimeout = setTimeout(() => {
        actions.setPostSuccessFalse();
      }, this.timeoutTime);
    }
  }

  checkAndRefreshToken() {
    const { actions } = this.props;
    actions.checkToken().then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, this._notificationSystem);
      } else {
        if (payload.status != "authorized") {
          actions.refreshToken().then(({ error, payload }) => {
            if (error || payload.error) {
              clearAuthCookie(cookie);
              this.redirectToLogin();
            } else {
              const { access_token, refresh_token, expires_in } = payload;
              let auth = {
                accessToken: access_token,
                refreshToken: refresh_token,
                expiresInDate: new Date().getTime() / 1000 + expires_in
              };
              setAuthCookie(cookie, auth);
            }
          });
        }
      }
    });
  }

  redirectToLogin() {
    window.location.href = "/";
  }

  onSetSidebarOpen(open) {
    const { actions } = this.props;
    actions.setSidebar("open", open);
  }

  componentWillUnmount() {
    const { settings, actions } = this.props;
    if (settings.mql) {
      settings.mql.removeListener(actions.updateMediaQuery);
    }
    if (settings.isOnlineInterval) {
      clearInterval(settings.isOnlineInterval);
    }
    if (settings.refreshTokenInterval) {
      clearInterval(settings.refreshTokenInterval);
    }
  }

  render() {
    // Use location pathname to ensure header is rerendered on url change, so
    // links update their active className.
    const {
      location: { pathname },
      history,
      msg,
      users: { viewer, currentUser },
      settings,
      actions,
      alerts,
      brokers,
      carers,
      contracts,
      offers,
      patients,
      invoices,
      payments,
      smss,
      audits
    } = this.props;

    const props = {
      ...this.props,
      notificationSystem: this._notificationSystem
    };

    const isNotLoggedPage =
      history.isActive("/login") ||
      history.isActive("/logout") ||
      history.isActive("/forgot") ||
      history.isActive("/set-password") ||
      pathname.startsWith("/set-password") ||
      history.isActive("*");

    let connected = "";
    if (settings.online) {
      connected = "Połączono!";
    } else {
      connected = "Brak połączenia z internetem!";
    }
    return (
      <div className="page" data-pathname={pathname}>
        <div
          className={classNames("is-online", {
            connected: settings.online,
            disconnected: !settings.online
          })}
        >
          <div className="text">{connected}</div>
        </div>
        <NotificationSystem ref="notificationSystem" allowHTML={true} />
        <div
          className={classNames("", {
            online: settings.online,
            offline: !settings.online
          })}
        >
          <Helmet
            meta={[
              {
                name: "description",
                content:
                  "Dev stack and starter kit for functional and universal React web apps"
              }
            ]}
          />

          <RouterHandler {...props} />
        </div>
        {(settings.patchCounter !== 0 ||
          settings.getCounter !== 0 ||
          settings.postCounter !== 0) && (
          <div className="la-ball-clip-rotate-wrapper">
            <div className="la-ball-clip-rotate">
              <div />
            </div>
          </div>
        )}
        {(settings.patchSuccess || settings.postSuccess) &&
        !(
          settings.patchCounter ||
          settings.getCounter ||
          settings.postCounter
        ) && (
          <div className="la-ball-clip-rotate-wrapper">
            <div className="patch-succes-sign" />
          </div>
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(
  DragDropContext(TouchBackend({ enableMouseEvents: true }))(App)
);



// WEBPACK FOOTER //
// ./src/browser/app/App.react.js